// i18n area 'networks' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.nl-NL.meta.json.
import type { enUS } from './networks'

export const nlNL: typeof enUS = {
  networks: {
    common: {
      name: 'Naam',
      scope: 'Scope',
      operState: 'Status',
      actions: 'Acties',
      create: 'Aanmaken',
      close: 'Sluiten',
      cancel: 'Annuleren',
      delete: 'Verwijderen',
      edit: 'Bewerken',
      save: 'Opslaan',
      editError: 'Bewerken mislukt',
      search: 'Zoek op naam',
      empty: 'Hier is nog niets',
      saveError: 'Opslaan mislukt',
      loadError: 'Laden mislukt — is de TVirt-backend bereikbaar?',
      createError: 'Aanmaken mislukt',
      deleteError: 'Verwijderen mislukt',
      deleteConfirmTitle: '{name} verwijderen?',
      deleteConfirmBody: 'Deze bewerking is niet terug te draaien.',
      nameHint: 'Kleine letters, cijfers en koppeltekens (DNS-1123)',
      up: 'Actief',
      down: 'Niet actief',
      unknown: 'Onbekend',
      usedByVMs: 'VM',
      emptyTable: 'Geen items — voeg er een toe met de +-knop'
    },
    dialogTabs: {
      general: 'Algemeen',
      base: 'Basisdefinitie',
      advanced: 'Geavanceerde configuratie',
      reserved: 'Voor TVirt gereserveerde ranges',
      position: 'Positie',
      network: 'Netwerkconfiguratie',
      hosts: 'Deelnemende nodes'
    },
    reservedRanges: {
      note: "Dit zijn de voor TVirt gereserveerde IP-ranges, die TVirt mag gebruiken om automatisch een adres toe te kennen aan VM's, containers enzovoort. LET OP: de adressen in deze ranges mogen buiten TVirt niet door externe diensten of apparatuur worden gebruikt.",
      from: 'Van',
      to: 'Tot'
    },
    overlay: {
      title: 'Overlaynetwerken',
      createTitle: 'Overlaynetwerk aanmaken',
      editTitle: 'Overlaynetwerk bewerken',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — automatisch toegewezen als je dit leeg laat',
      subnet: 'Subnet',
      subnetHint: 'De CIDR van de overlay — de IPAM leidt de registervermelding er automatisch uit af',
      mtu: 'MTU',
      weight: 'Gewicht',
      ceilMbps: 'Plafond (Mbps)',
      fairnessHint: 'Het gewicht telt alleen bij congestie: op een vrije link mag elk netwerk de volledige bandbreedte gebruiken. Het plafond geldt daarentegen altijd.',
      contention: 'Concurrentie',
      contentionTip: 'Minstens één node ziet drops of overlimits MET een wachtrij op de klasse van dit netwerk: de uplink-bandbreedte wordt betwist en de gewichten grijpen in. Hoeveel en sinds wanneer staat in de net.shaping.*-reeksen van de node.',
      firewallPolicy: 'Firewallbeleid',
      hosts: 'Hosts',
      hostsTitle: 'Deelnemende nodes',
      hostsHint: 'Elke node declareert zijn underlay-endpoint — een select op de ECHTE adressen van de node, gelezen uit zijn netwerkconfiguratie; het optionele overlayadres moet binnen het subnet vallen. De deelname is de placementbeperking.',
      hostNode: 'Node',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Kies eerst de node',
      hostAddress: 'Adres op de overlay (optioneel)',
      hostAddressOutside: 'Buiten het overlay-subnet ({cidr})',
      addHost: 'Node toevoegen',

      // Round #156 (dialog standard): de waargenomen regels van de detaildialog.
      observedAt: 'Waargenomen op',
      attachedNics: "Gekoppelde NIC's"
    },
    services: {
      title: 'Netwerkdiensten',
      createTitle: 'Netwerkdienst aanmaken',
      editTitle: 'Netwerkdienst bewerken',
      kind: 'Type',
      kindCategory: 'Diensten',
      selectKindHint: 'Kies het type dienst — de onderliggende daemon is een implementatiedetail dat TVirt voor je beheert.',
      kindLabel: {
        dhcp: 'DHCP-server',
        ntp: 'NTP-server',
        vpn: 'VPN-server',
        dns: 'DNS-server',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer en reverse proxy',
        floatip: 'Zwevend IP'
      },
      kindDesc: {
        dhcp: 'Kent adressen toe op de bediende subnets — de pools volgen uit het subnet, de gateway en de voor TVirt gereserveerde ranges van het netwerk.',
        dns: 'Autoritatieve DNS op de gedeclareerde zones — de records volgen uit de IPAM plus je eigen handmatige records.',
        gateway: 'De node fungeert als gateway voor een netwerk — NAT (DNAT, 1:1, SNAT/masquerade) plus statische routering tussen de aangesloten netwerken, zelfherstellend van opzet.',
        'lb-rp': 'Loadbalancer / reverse proxy vóór je diensten — L4- of L7-listeners over pools van leden of over de gereed staande instanties van een Pod, on-the-fly geherconfigureerd.',
        ntp: 'De tijddienst van de netwerken — relay van externe upstream-servers, of de klok van de bedienende node die aan de clients wordt geserveerd.',
        vpn: 'Een VPN-concentrator op de node — WireGuard of OpenVPN, jij kiest: externe toegang voor reizende clients, of een site-to-site-tunnel tussen twee netwerken.',
        floatip: 'Eén adres dat op één gezonde App-instantie of Pod tegelijk staat en naar het volgende gezonde doel verhuist wanneer dat wegvalt — failover zonder daemons; de balancering blijft bij de loadbalancer.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Het zwevende IP leeft op het gekozen netwerk als EXTRA adres binnen de eigen namespace van de houdende instantie: geen poorten, geen balancering, geen NAT — het client-IP blijft echt.',
        address: 'Zwevend IP',
        targets: 'Doelen',
        targetsHint: 'In volgorde van VOORKEUR: het eerste gezonde doel houdt het adres. Een Pod staat voor al zijn instanties, per replica; elk doel heeft zijn eigen gezondheidscriterium. Elk doel moet aan hetzelfde netwerk hangen.',
        targetKind: 'Doel',
        targetApp: 'App-instantie',
        targetPod: 'Pod (alle instanties)',
        targetRef: 'Welke',
        health: 'Gezondheid',
        healthRunning: 'Actief (elke container gereed)',
        healthTcp: 'TCP-verbinding',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Poort',
        path: 'Pad',
        addTarget: 'Doel toevoegen',
        moveUp: 'Omhoog',
        moveDown: 'Omlaag',
        preempt: 'Preempt',
        preemptHint: 'Uit (standaard): een gezonde houder behoudt het adres ook als een hoger doel terugkomt — geen flapping. Aan: het eerste gezonde doel houdt het altijd.',
        holder: 'Houder',
        noHolder: 'geen gezond doel',
        since: 'sinds',
        verdicts: 'Waargenomen doelen',
        healthy: 'gezond',
        unhealthy: 'ongezond',
        noVerdict: 'Nog niet beslist — de autoriteitsnode schrijft het eerste oordeel bij zijn volgende ronde.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Deze instantie houdt het zwevende IP {address} van dienst {service}'
      },
      poolSource: 'Endpoints',
      poolSourceMembers: 'Statische leden',
      poolSourcePod: 'De gereed staande instanties van een Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Poort',
      poolBackendHint: 'De endpoints volgen de Pod: een instantie treedt toe zodra ze draait met elke container gereed, en verlaat meteen wanneer ze wordt afgeschaald of sterft. De actieve check staat standaard aan.',
      poolBackendCount: 'de gereed staande instanties van Pod {pod} op poort {port}',
      node: 'Node',
      enabled: 'Ingeschakeld',
      parked: 'Geparkeerd',
      subnets: 'Subnets',
      subnetsHint: 'De IPAM-subnets die deze instantie bedient — de pools volgen uit de CIDR, de gateway en de voor TVirt gereserveerde ranges',
      noSubnets: 'Geen IPAM-subnets — declareer eerst een logisch fabricnetwerk (of een overlaysubnet): de IPAM leidt zich daaruit af',
      iface: 'Luisterinterface',
      ifaceHint: 'De hostinterface waarop de service zijn socket opent (bijv. een bridge) — verplicht: een netwerkservice is zelfstandig, "alle interfaces" bestaat niet meer',
      dns: 'DNS-servers',
      domain: 'Domein',
      detail: 'Bedient',
      subnetCount: '{n} subnets',
      zones: 'Zones',
      zonesHint: 'Alleen autoritatief — de daemon doet nooit recursie. De A-records volgen uit de gedeclareerde adressen van de nodes in de gerefereerde IPAM-subnets; de reverse-schakelaar bedient ook de bijbehorende in-addr.arpa-zones (PTR). Een zone wordt door hoogstens één DNS-instantie in de fleet bediend. De optionele nameserver is de FQDN die in de NS/SOA-records terechtkomt in plaats van de standaard ns.<zone>; valt hij binnen de zone, dan volgt zijn A-record alsnog uit de bedienende node.',
      zoneName: 'Zonenaam',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM-subnets',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Handmatige records',
      zoneRecordsHint: 'Eén per regel: naam TYPE waarde — types A, CNAME, MX, TXT. Bij een botsing op de naam wint het handmatige record van het afgeleide.',
      addZone: 'Zone toevoegen',

      // lb-rp (wave 3, fundering): listeners op inline pools — engine-less,
      // in de lucht herconfigureerd.
      lbListeningHint: 'De instantie declareert ÉÉN luisternetwerk en ÉÉN adres — elke listener bindt het op zijn eigen poort; een tweede adres is een tweede service.',
      listeners: 'Listeners',
      listenersHint: 'Elke listener bindt het adres van de instantie op zijn eigen poort in modus L4 (TCP-passthrough — de bytes worden nooit geopend) of L7 (HTTP) en stuurt door naar een van de pools hieronder. Een adres/poort-paar wordt door hooguit één instantie per node bediend. Wijzigingen gelden in vlucht — geen herstart, geen verloren verbindingen.',
      listenerName: 'Naam',
      listenerMode: 'Modus',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP-passthrough',
      listenerPort: 'Poort',
      listenerPool: 'Pool',
      addListener: 'Listener toevoegen',
      pools: 'Pools',
      poolsHint: 'De backends waar het verkeer landt: statische members, verdeeld via round robin of via minst belast, met een optionele actieve health check die zieke members uit de rotatie haalt.',
      poolName: 'Naam',
      poolAlgorithm: 'Algoritme',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Minst belast',
      poolCheck: 'Health check',
      checkNone: 'Geen',
      checkTcp: 'TCP-verbinding',
      checkHttp: 'HTTP',
      poolCheckPath: 'Pad van de probe',
      poolInterval: 'Interval (s)',
      poolMembers: 'Members',
      poolMembersHint: 'Eén per regel: adres:poort, eventueel gevolgd door een gewicht (1-128) — bijv. 10.0.0.21:8080 2',
      addPool: 'Pool toevoegen',
      memberCount: '{n} members',

      // ntp (ronde ntp — geratificeerd 2026-08-03, het laatste kind van de
      // familie): de modus in gewone woorden, de upstream-lijst alleen waar hij
      // iets betekent, de netwerkaanhechting hergebruikt de labels van de gateway.
      listen: {
        assignment: 'Toewijzing',
        assignmentStatic: 'Statisch adres',
        assignmentAuto: 'Automatisch (TVirt-gereserveerde reeksen)',
        autoHint: 'TVirt haalt het adres uit de gereserveerde reeksen van het logische netwerk en houdt het sticky — nooit opnieuw getrokken bij een edit of failover.',
        title: 'Listeners',
        hint: 'Een netwerkservice is zelfstandig: elke listener declareert zijn netwerk (overlay, logisch fabric-netwerk of rauwe interface) en een adres binnen zijn subnet — één listener per adres, de wildcard bestaat niet meer. DNS en NTP mogen op meerdere netwerken en meerdere adressen van die netwerken luisteren.',
        address: 'Luisteradres',
        add: 'Listener toevoegen'
      },
      ntp: {
        mode: 'Synchronisatiemodus',
        modeRelay: 'Relay van externe servers',
        modeNodeClock: 'Klok van de node',
        modeHint: 'De relay serveert de tijd die van de gedeclareerde upstream-servers komt; de klok van de node serveert de tijd van de bedienende node — die het cluster hoe dan ook gesynchroniseerd houdt',
        servers: 'Upstream-servers',
        serversHint: "Gescheiden door komma's — hostnaam of IP-adres; de dienst haalt de tijd hier op en serveert die aan het netwerk",
        port: 'Luisterpoort',
        listening: 'Luistert op'
      },

      vpn: {
        engine: 'Engine',
        engineHint: 'Jij kiest hem, en daarna verandert hij niet meer: WireGuard is modern, snel en zit in de kernel; OpenVPN is de veteraan van de compatibiliteit (TCP, vijandige netwerken)',
        engineLocked: 'De engine ligt vast — een andere engine is een nieuwe dienst, sleutels en certificaten zijn niet overdraagbaar',
        mode: 'Modus',
        modeRemote: 'Externe toegang',
        modeSite: 'Site to site',
        modeHint: 'Externe toegang geeft reizende clients een adres in de tunnel; site to site verbindt twee netwerken',
        port: 'Luisterpoort',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard spreekt alleen UDP',
        tunnelSubnet: 'Subnet van de tunnel',
        tunnelSubnetHint: 'Het netwerk waarin de clients leven — vastgelegd in het IPAM-register, het ontstaat en verdwijnt met deze dienst',
        dnsServers: 'DNS gepusht naar de clients',
        routes: 'Routes gepusht naar de clients',
        routesHint: "Netwerken gescheiden door komma's die via de tunnel bereikbaar zijn; het subnet van de tunnel zit er altijd bij",
        peers: 'Peers',
        peersHint: 'Laat de publieke sleutel leeg en TVirt genereert het sleutelpaar — en levert het mee met het profiel. Plak je een sleutel, dan houdt de peer zijn eigen sleutel.',
        clients: 'Clients',
        clientsHint: 'Elke client krijgt een certificaat uitgegeven door de CA van deze dienst. Een client weghalen betekent INTREKKEN: de CRL wordt meteen opnieuw gegenereerd.',
        peerName: 'Naam',
        publicKey: 'Publieke sleutel',
        publicKeyMinted: 'TVirt genereert hem',
        peerAddress: 'Adres in de tunnel',
        peerAddressHint: 'Leeg = toegewezen',
        allowedIps: 'Remote subnets',
        allowedIpsHint: "Gescheiden door komma's, gerouteerd via deze peer",
        endpoint: 'Endpoint',
        presharedKey: 'Vooraf gedeelde sleutel',
        keepalive: 'Keepalive (s)',
        addPeer: 'Peer toevoegen',
        addClient: 'Client toevoegen',
        auth: 'Authenticatie',
        authTls: 'Certificaten (TLS)',
        remote: 'Remote endpoint',
        remoteHint: 'host:poort van de andere kant — leeg betekent dat deze kant wacht',
        peerRoutes: 'Remote subnets',
        serverPublicKey: 'Publieke sleutel van deze server',
        ca: 'Certificaatautoriteit',
        listening: 'Luistert op',
        tunnel: 'Tunnel',
        peerCount: '{n} peers',
        download: 'Profiel downloaden',
        downloadError: 'Het profiel kon niet worden geëxporteerd',
        lastHandshake: 'Laatste handshake',
        never: 'nooit',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Verbonden',
        idle: 'Inactief'
      },

      // Gateway (wave 3 — geboren als nat, geratificeerd 2026-08-01/02;
      // hernoemd en uitgebreid op 2026-08-03): de drie families NAT-regels plus
      // de statische routes op een luisternetwerk. Elke geratificeerde vorm
      // wordt ondersteund.
      gateway: {
        attach: 'Type luisternetwerk',
        attachOverlay: 'Overlaynetwerk',
        attachNetwork: 'Logisch fabricnetwerk',
        attachInterface: 'Ruwe interface',
        overlay: 'Overlaynetwerk',
        network: 'Logisch netwerk',
        interface: 'Interfacenaam',
        interfaceHint: 'Een host-interface die TVirt niet beheert — het adres wordt voor waar aangenomen',
        address: 'Luisteradres (gateway)',
        addressHint: 'Het gatewayadres waar de clients naar wijzen — binnen het subnet van het luisternetwerk',
        dnatTitle: 'DNAT-regels',
        dnatHint: 'Bestemmings-NAT: verkeer dat matcht wordt omgeleid naar een nieuw adres (en eventueel een nieuwe poort). Elk protocol uit de lijst — met de poorten die bij dat protocol horen.',
        snatTitle: 'SNAT-regels',
        snatHint: 'Bron-NAT: verkeer dat matcht vertrekt met een herschreven bron — een expliciet nieuw adres (en eventueel een nieuwe poort), of masquerade op het uitgaande adres als je het leeg laat.',
        oneToOneTitle: '1:1-NAT-regels',
        oneToOneHint: 'Elk pakket voor het externe adres wordt op het interne gemapt, en de interne host vertrekt als het externe — alle protocollen, beide richtingen.',
        external: 'Extern adres',
        internal: 'Intern adres',
        addOneToOne: '1:1-regel toevoegen',
        family: 'Familie',
        protocol: 'Protocol',
        source: 'Bron (adres/subnet)',
        destination: 'Bestemming (adres/subnet)',
        invert: 'NOT',
        srcPorts: 'Bronpoorten',
        dstPorts: 'Bestem. poorten',
        dstPortsHint: 'Poort of range (80, 8000-8099)',
        toAddress: 'Nieuw adres',
        toPort: 'Nieuwe poort',
        snatTo: 'Nieuwe bron (leeg = masquerade)',
        snatToHint: 'Expliciet bronadres; leeg = masquerade op het uitgaande adres',
        addDnat: 'DNAT-regel toevoegen',
        addSnat: 'SNAT-regel toevoegen',
        routesTitle: 'Statische routes',
        routesHint: 'De node routeert tussen de netwerken waaraan hij hangt (IP forwarding staat aan); deze routes voegen daar bereikbaarheid aan toe — pure kernel, dynamische routering komt in een latere ronde.',
        routeDestination: 'Bestemmingssubnet',
        routeGateway: 'Next hop',
        routeMetric: 'Metriek',
        addRoute: 'Route toevoegen',
        listening: 'Luistert op',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} routes'
      },
      unknownSince: 'Onbekend — laatste report {m} min geleden',
      lastWord: 'Laatste woord',

      // Round #156 (dialog standard): de waargenomen regels en de
      // alleen-lezen samenvatting van het kind-blok in de detaildialog.
      reportObservedAt: 'Laatste report',
      lastErrorRow: 'Laatste fout',
      recordsCount: '{n} handmatige records',
      phase: {
        configured: 'Geconfigureerd',
        running: 'Wordt uitgevoerd',
        error: 'Fout'
      },
      authorityNode: 'Authority (toewijzing)',
      preferredNode: 'Voorkeursnode',
      preferredNodeHint: 'Een zachte voorkeur, nooit een beperking: bij de volgende placementbeslissing landt de instantie hier als het lid geschikt is — op zichzelf verplaatst dit niets; de zet is "Authority overdragen".',
      noPreference: 'Geen voorkeur (automatische placement)',
      moving: 'In beweging',
      movingTooltip: 'Hier waargenomen terwijl de authority {node} toewijst: de zet convergeert.',
      placement: {
        title: 'Placement',
        loading: 'Inventarisatie bezig…',
        loadError: 'De placement-inventarisatie heeft niet geantwoord — probeer het later opnieuw.',
        draftHint: 'De inventarisatie wordt berekend op de gedeclareerde netwerkkoppeling: hij verschijnt zodra de dienst bestaat. Het aanmaken wordt geweigerd als geen enkel lid hem kan bedienen, en de weigering noemt het mechanisme dat de verzameling heeft leeggemaakt.',
        eligibleCount: '{n} van de {m} leden kunnen deze instantie bedienen',
        recommended: 'Aanbevolen',
        eligible: 'Geschikt',
        notEligible: 'Niet geschikt',
        blockedReachability: 'het netwerk komt niet aan op dit lid',
        blockedRequireTag: 'geblokkeerd door een vereiste tag (requireNodes)',
        blockedExcluded: 'door de simulatie uitgesloten',
        preferenceUnknown: 'is geen (of niet langer) lid van het cluster',
        preferenceIgnored: 'De voorkeur "{node}" is vandaag niet geschikt: {reason}. De aanbeveling van de inventarisatie wint — nooit een fout, de dienst leeft elders.',
        emptyReachability: 'Geen enkel lid kan deze instantie bedienen: het netwerk komt nergens aan — geen enkele tag-aanpassing zal helpen. Bekabel de node, of verplaats de dienst naar waar het netwerk wél is.',
        emptyRequireTag: 'Geen enkel lid kan deze instantie bedienen: het zijn de vereiste tags die de verzameling hebben leeggemaakt — haal de regel uit requireNodes, of geef een lid de tag.',
        spof: 'Single point of failure',
        spofDetail: 'Slechts één lid kan de instantie herbergen: bij een storing kan de failover nergens heen. Een multi-listener-dienst verhuist als EENHEID — de kandidaat moet AL zijn netwerken zien: dat is de prijs.',
        whatIf: 'Afwezige leden simuleren',
        whatIfHint: 'De what-if van de drain: vraag het VÓÓR de evacuatie, ontdek het niet pas bij de failover.',
        survives: 'Met {nodes} afwezig heeft de dienst nog steeds een thuis.',
        notSurvives: 'Wie {nodes} evacueert, legt deze dienst PLAT: de afgeleide beperking wint van de beschikbaarheid (R30) — een daemon die leeft waar het netwerk niet aankomt, bedient niemand en alarmeert niemand.',
        transfer: 'Authority overdragen',
        transferError: 'Overdracht mislukt',
        transferTarget: 'Doellid',
        transferHint: 'Alleen geschikte leden worden aangeboden — een voorkeur binnen de geldige verzameling, nooit een override. Geen task: de eerstvolgende ronde van de workers IS de zet (de oude node maait, de nieuwe bouwt op).'
      }
    },
    fabric: {
      tabDerivation: 'Derivatie',
      importNetwork: 'Importeren uit een andere fabric',
      importTitle: 'Een logisch netwerk importeren',
      importHint: 'De import is de expliciete toetreding: het netwerk blijft van de eigenaar (dezelfde identiteit, dezelfde stem, dezelfde bridge tvf-<stem>) en van hieruit wordt het gemapt op de poorten/LAGG’s van deze fabric — mappen IS beweren dat de levering uitkomt in hetzelfde L2-domein als dat van de eigenaar.',
      importPick: 'Netwerk van de eigenaar',
      importNone: 'Niets te importeren: de andere fabrics hebben geen eigen netwerk dat deze fabric nog niet kent',
      importedNetworksTitle: 'Geïmporteerde netwerken',
      noImported: 'Geen geïmporteerd netwerk',
      importedFrom: 'geïmporteerd uit {fabric}',
      importedBy: 'Geïmporteerd door: {list}',
      importedCount: '+{n} geïmporteerd',
      owner: 'Eigenaar',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Import verwijderen',
      unimportConfirm: 'De import van netwerk {name} (eigenaar {fabric}) uit deze fabric verwijderen? Wordt geweigerd zolang een poort of LAGG van deze fabric het mapt, of een gast, App of dienst alleen via deze poot wordt bediend.',
      unimportRefused: 'Import nog in gebruik — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Deze node neemt dat netwerk al af van een andere fabric waarvan hij lid is: een node neemt een gedeeld netwerk via ÉÉN van zijn poten (twee uplinks van hetzelfde L2 in een bridge zonder STP zijn een loop). Haal de mapping weg op de poorten of de LAGG van een van de twee fabrics.',
          otherFabricDerived: 'Het document draagt het blok van een fabric waarnaar de node geen kabel meer declareert: pas eerst het plan van die fabric toe (het stelt de verwijdering van zijn devices voor), of neem ze over met take-ownership als de fabric weg is.'
        },
        hint: 'Het O.3-derivatieplan: per bekabelde node de status, de diff afgeleid-vs-huidig, de GEDECLAREERDE bond-topologie, de dual-stack flips en de gestructureerde weigeringen/waarschuwingen. Alleen-lezen tot de EXPLICIETE apply — niets landt ooit vanzelf op een node.',
        refresh: 'Plan herladen',
        empty: 'Geen enkele node is aan deze fabric bekabeld (en geen enkele draagt nog haar blok).',
        refusal: 'Weigering',
        warning: 'Waarschuwing',
        generation: 'documentgeneratie {n}',
        state: {
          manual: 'Handmatig',
          derived: 'Afgeleid',
          diverged: 'Afgeweken'
        },
        topologyTitle: 'Gedeclareerde topologie',
        members: 'leden',
        primary: 'primair',
        held: 'op ÉÉN lid gehouden',
        form: {
          perNetworkBond: 'Bond per netwerk',
          singleBond: 'Enkele fallback-bond',
          laggBond: 'LACP-bond (LAGG)',
          singlePort: 'Enkele poort'
        },
        colAction: 'Actie',
        colKind: 'Soort',
        colDevice: 'Device',
        colDetail: 'Detail',
        action: {
          add: 'toevoegen',
          remove: 'verwijderen',
          replace: 'vervangen'
        },
        diffEmpty: 'Geen openstaande diff — het toegepaste document komt overeen met de render.',
        diffBlocked: 'Geen diff: de weigeringen hierboven blokkeren deze node.',
        phasePlanned: 'gepland (stap 1 van 3)',
        phaseDraining: 'aan het leeglopen (stap 2 van 3)',
        probeUnobserved: 'Drain-sonde: nooit gerapporteerd — de leegte is ONBEKEND (een retire zou nu geweigerd worden).',
        probeFailed: 'Drain-sonde: observatie MISLUKT — de bekende tijdstempels blijven staan, nooit een «leeg» dat niemand heeft gemeten.',
        probeActive: {
          one: 'Drain-sonde: {n} bestaande verbinding nog op het oude adres',
          other: 'Drain-sonde: {n} bestaande verbindingen nog op het oude adres'
        },
        probeLastActive: 'laatste activiteit {time}',
        probeEmpty: {
          one: 'Drain-sonde: leeg sinds {n} minuut',
          other: 'Drain-sonde: leeg sinds {n} minuten'
        },
        probeEmptyUnknown: 'Drain-sonde: leeg (sinds wanneer is onbekend).',
        impact: '{nics} vNIC\'s en {apps} Apps op deze node gebruiken deze netwerken: {list}',
        apply: 'Op deze node toepassen',
        applyTitle: 'Derivatie toepassen — {node}',
        applyIntro: 'De afgeleide configuratie herschrijft het netwerkdocument van {node} ({n} wijzigingen) door dezelfde deur als de host-network-editor — NetworkManager-checkpoint en eerlijke probe inbegrepen. De planwaarschuwingen hieronder reizen mee: lees ze vóór het bevestigen.',
        applyError: 'Apply mislukt',
        applyRefused: 'De node weigerde:',
        planMoved: 'De fabric is veranderd na deze preview — NIETS is toegepast. Het plan is herladen: kijk opnieuw en probeer het nog eens.',
        retire: 'Uitfaseren',
        retireTitle: 'Punt van geen terugkeer — uitfaseren van {address}',
        restore: 'Herstellen',
        restoreTip: 'Terug naar de snapshot van vóór de apply (generatie {previous}) — de undo in één stap (H13)',
        restoreTitle: 'Vorig document herstellen — {node}',
        restoreIntro: 'Het netwerkdocument van {node} gaat terug naar de snapshot van vóór de laatste apply (generatie {previous}), herschreven als generatie {next} in plaats van {current}. De worker convergeert het zoals elk ander document.',
        restoreRedo: 'Het vervangen document wordt de nieuwe snapshot: opnieuw herstellen is de redo.',
        restoreClosesChain: 'De snapshot is het handmatige document van vóór de afleiding: de keten sluit hier — geen verdere undo, de node blijft handmatig tot de volgende apply.',
        restoreConfirm: 'Herstellen',
        restoreError: 'Herstel mislukt',
        retireIntro: 'Dit verwijdert {address} ({network}) definitief van {point}. Na deze daad is de weg terug de OMGEKEERDE flip — het oude adres opnieuw declareren via dezelfde engine — nooit een blind herstel.',
        retireOld: 'Oud adres (verwijderd)',
        retireNew: 'Nieuw adres (blijft)',
        retireEmptyFact: 'De drain-sonde meldt het adres leeg: deze verwijdering verbreekt geen waargenomen verbinding.',
        retireConfirm: 'Adres uitfaseren',
        severActiveLoss: {
          one: '{n} bestaande verbinding op het oude adres verbreken — ze sterft met deze daad',
          other: '{n} bestaande verbindingen op het oude adres verbreken — ze sterven met deze daad'
        },
        severUnknownLoss: 'Het ONBEKENDE accepteren: de sonde heeft dit adres nooit waargenomen (of de observatie faalt) — levende verbindingen kunnen verbroken worden.'
      },
      title: 'Fabric',
      createTitle: 'Fabric aanmaken',
      networks: 'Netwerken',
      switches: 'Switches',
      ports: 'Poorten',
      laggs: 'LAGG',
      subnets: 'Subnets',
      tabOverview: 'Overzicht',
      tabNetworks: 'Logische netwerken',
      tabSwitches: 'Switches',
      overviewHint: "De fabric in één oogopslag: elk logisch netwerk met MTU en subnet (de VLAN's leven alleen in de mappings per poort of per LAGG — hetzelfde netwerk kan met verschillende tags over verschillende poorten reizen). De fabric is het register van een EXTERNE infrastructuur — TVirt observeert en declareert, doet nooit provisioning, en raakt alleen de NIC's aan die onder zijn beheer geregistreerd staan.",
      absorptionHint: 'Elk subnet dat hier wordt gedeclareerd LEIDT in dezelfde schrijfactie zijn vermelding in het IPAM-register af — het leeft en sterft met het netwerk.',
      scopeFixedHint: 'De scope ligt vast op de clusterroot: fysieke infrastructuur is per definitie clusterbreed.',
      networksHint: "Elk netwerk draagt een verplichte MTU (standaard 1500) en een verplicht subnet; de gateway, de DNS-servers en de statische routes die hier worden gedeclareerd zijn de ENIGE BRON voor de NIC's van de servers, de Apps en de netwerkdiensten.",
      switchesHint: 'Het handmatige register: een poort is ongebruikt, gemapt (untagged verkeer en per VLAN-tag op de logische netwerken) of lid van een LAGG — een lid draagt geen eigen mappings.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Verplicht — de IPAM leidt de registervermelding er automatisch uit af',
      nodeAddressing: 'Node-adressering',
      nodeAddressingNone: 'Geen — geen adres per node',
      nodeAddressingPool: 'Pool — één vast adres per bediende node',
      nodeAddressingHint: 'Met Pool wijst de fabric-afleiding elke bediende node een adres toe uit de voor TVirt gereserveerde bereiken (vast zodra toegewezen).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Gereserveerde ranges',
      dns: "DNS-servers (gescheiden door komma's)",
      dnsShort: 'DNS',
      singleSourceHint: "Gateway, DNS en routes die hier worden gedeclareerd zijn de enige bron — de NIC's van de servers, de Apps en de netwerkdiensten putten hieruit",
      routesTitle: 'Statische routes',
      routeDestination: 'Bestemming (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Gebruikt',
      vlanMappings: 'VLAN-mappings',
      vlanTag: 'VLAN-tag',
      vlanNetwork: 'Logisch netwerk',
      nameTaken: 'Naam al in gebruik in de fabric',
      addNetwork: 'Netwerk toevoegen',
      editNetwork: 'Netwerk bewerken',
      deleteNetwork: 'Netwerk weghalen',
      deleteNetworkConfirm: 'Het logische netwerk {name} uit de fabric weghalen? Het daaruit afgeleide subnet in de IPAM sterft met het netwerk mee (geweigerd zolang een dienst of een App het gebruikt). Poort- en LAGG-mappings die ernaar verwijzen worden opgeschoond.',
      switchName: 'Switch',
      portName: 'Poort',
      positionHint: 'Fysieke positie (optioneel) — dezelfde woordenschat als bij de plaatsing van servers; puur declaratief',
      addSwitch: 'Switch toevoegen',
      editSwitch: 'Switch bewerken',
      deleteSwitch: 'Switch weghalen',
      deleteSwitchConfirm: "De switch {name} met al zijn poorten weghalen? De LAGG's krimpen navenant mee (en sterven onder de twee poorten).",
      addPort: 'Poort toevoegen',
      editPort: 'Poort bewerken',
      deletePort: 'Poort weghalen',
      deletePortConfirm: 'De poort {name} weghalen?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:netwerk)',
      taggedShort: 'Tagged',
      portCabling: 'Bekabeling',
      portState: 'Status',
      stateUnused: 'ongebruikt',
      stateMapped: 'gemapt',
      laggPortGuard: 'Een poort die lid is van een LAGG pas je aan vanaf de LAGG-kant',
      laggsTitle: 'LAGG',
      laggsHint: 'Een LAGG is 2+ poorten in LACP en mag over switches heen lopen (MLAG, transparant); alleen ongebruikte poorten mogen erin, de LAGG is het mappingoppervlak, en een weggehaalde poort wordt weer ongebruikt.',
      addLagg: 'LAGG toevoegen',
      editLagg: 'LAGG bewerken',
      deleteLagg: 'LAGG weghalen',
      deleteLaggConfirm: 'De LAGG {name} weghalen? De poorten die er lid van zijn worden weer ongebruikt.',
      lacpRate: 'LACP-rate',
      laggPorts: 'Lidpoorten (2+)',
      laggPortsHint: 'Alleen ongebruikte poorten mogen erin — maak eerst een gemapte poort vrij',
      noNetworks: 'Geen logische netwerken gedeclareerd.',
      noSwitches: 'Geen switches gedeclareerd.',
      noLaggs: "Geen LAGG's gedeclareerd.",
      staleConflict: 'Een andere operator heeft deze fabric gewijzigd terwijl jij hem aan het bewerken was: het opslaan is geweigerd om zijn werk niet te wissen. Jouw wijzigingen staan er nog, onaangetast. De bijgewerkte fabric is al opnieuw geladen: bevestig opnieuw om ze er bovenop toe te passen, of annuleer en kijk wat er veranderd is.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Alleen afgeleid: elk subnet ontstaat uit een logisch fabricnetwerk of uit een overlay — je wijzigt het bij de bron. De toegekende adressen laten zien WIE ze in handen heeft; de voor TVirt gereserveerde ranges zijn de pools voor de automatische toekenning.',
      search: 'Zoeken op naam, CIDR of adres',
      empty: 'Geen netwerken — declareer een logisch fabricnetwerk of een overlaysubnet: de IPAM leidt zich daar automatisch uit af.',
      reserved: 'Voor TVirt gereserveerde ranges',
      address: 'Adres',
      origin: 'Herkomst',
      origin_declared: 'gedeclareerd',
      origin_observed: 'waargenomen',
      holder: 'In handen van',
      noAddresses: 'Geen bekende adressen in dit subnet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Bij de bron bewerken'
    },
    firewall: {
      title: 'Firewallgroepen',
      createTitle: 'Nieuwe firewallgroep',
      editTitle: 'Firewallgroep bewerken',
      empty: "Geen firewallgroepen — maak er een: een herbruikbaar vocabulaire van regels, waar gast-NIC's op naam naar verwijzen.",
      nameHint: 'Letters, cijfers en . - _ binnenin; uniek binnen zijn scope (naamgenoten elders onderscheid je met /scope/naam)',
      description: 'Beschrijving',
      descriptionHint: 'Eén regel over de bedoeling, getoond overal waar de groep gekozen wordt',
      enforced: 'Opgelegd aan de scope',
      enforcedHint: "Uit: puur vocabulaire — de regels binden alleen de NIC's die naar de groep verwijzen. Aan: de regels binden elke gast-NIC met ingeschakelde firewall onder de scope van de groep, met of zonder verwijzing.",
      enforcedChip: 'Opgelegd',
      enforcedChipHint: 'De regels binden elke gast-NIC met ingeschakelde firewall onder de scope van de groep, met of zonder verwijzing',
      enforceWarning: 'Met het opleggen binden de regels bij de volgende afstemming ELKE gast-NIC met ingeschakelde firewall onder {scope}, ook zonder expliciete verwijzing — en binnen een actieve chain is de drop van een voorouder definitief: de niveaus eronder openen hem niet opnieuw.',
      unenforceInfo: "Zonder het opleggen blijven de regels alleen op de NIC's die expliciet naar de groep verwijzen.",
      rules: 'Regels',
      tabOverview: 'Overzicht',
      tabRules: 'Regels',
      orderHint: 'De volgorde van de rijen IS de evaluatievolgorde binnen de groep: de eerste regel die past wint.',
      statefulHint: 'Stateful is impliciet: antwoorden op toegelaten verkeer passeren vanzelf (established/related geaccepteerd, invalid weggegooid — de engine injecteert ze, met de hand schrijf je ze nooit).',
      noRules: 'Geen regels — een vocabulaire in aanbouw: ernaar verwijzen mag en rendert niets.',
      addRule: 'Regel toevoegen',
      direction: 'Richting',
      directionIn: 'Inkomend',
      directionOut: 'Uitgaand',
      action: 'Actie',
      action_accept: 'Accepteren',
      action_drop: 'Verwerpen',
      action_reject: 'Weigeren',
      protocol: 'Protocol',
      protocolAny: 'Elk',
      ports: 'Poorten',
      source: 'Bron',
      dest: 'Bestemming',
      comment: 'Opmerking',
      addressHint: 'IPv4-CIDR of <fabric>/<logisch netwerk>; leeg = alles',
      moveUp: 'Omhoog',
      moveDown: 'Omlaag',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Firewallgroepen',
      nicGroupsPlaceholder: 'Kies een groep…',
      nicGroupsHint: 'De zichtbare groepen, inclusief die van de bovenliggende scopes (naar beneden bruikbaar, zoals de tags)',
      nicGroupCount: { one: '{n} firewallgroep', other: '{n} firewallgroepen' },
      nicOff: 'Firewall uit',
      pendingRestartHint: 'Firewallwijzigingen volgen het model opgeslagen/toegepast: ze wachten op de volgende power cycle (PendingRestart). Groepen die bovenliggende scopes opleggen gelden wanneer de firewall van de NIC aan staat.',
      appConvergeHint: 'Firewallwijzigingen gelden vanaf de volgende afstemming van de container. Groepen die bovenliggende scopes opleggen gelden wanneer de firewall aan staat.',
      enforcedAncestors: 'Opgelegd door bovenliggende scopes',
      enforcedAncestorsHint: 'Deze groep geldt voor elke NIC onder zijn scope waarvan de firewall AAN staat — de schakelaar is de hoofdschakelaar van de NIC (uit = helemaal geen chain, voorouders inbegrepen); binnen een actieve chain is het gezag van de voorouder definitief: zijn drop wordt eronder niet heropend.'
    }
  }
}
